<header class="container-fluid">
  <div class="row">
    <div class="col-md-4">
      <img src="/assets/3.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <h2>
        {{ "about us" | translate }}
      </h2>
    </div>
    <div class="col-md-4">
      <img src="/assets/1.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/5.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/2.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/4.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/8.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/7.png" alt="" />
      <div class="overlay"></div>
    </div>
    <div class="col-md-4">
      <img src="/assets/6.png" alt="" />
      <div class="overlay"></div>
    </div>
  </div>
</header>

<div>
  <h2>new Furniture {{ "for office Furniture" | translate }}</h2>

  <div class="container">
    <section
      *ngFor="let item of aboutUsData; index as i"
      [ngClass]="{ flip: i % 2 == 1 }"
    >
      <div class="row">
        <div class="col-md-8">
          <h4 style="text-align: center;">
            {{ item.name }}
          </h4>
          <p>
            {{ item.description }}
          </p>
        </div>
        <div class="col-md-4">
          <img src="{{ item.image }}" alt="" />
          <div class="overlay"></div>
        </div>
      </div>
    </section>
  </div>
</div>
